import { CheckCircle, ContentCopy } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { GREEN400 } from '../../../theme';

const CopyIconButton: React.FC<{
  text: string;
  fontSize?: number;
}> = ({ text, fontSize = 13 }) => {
  const [copied, setCopied] = React.useState(false);

  const onCopy = () => {
    setCopied(true);
  };

  React.useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  return (
    <CopyToClipboard text={text} onCopy={onCopy}>
      <IconButton style={{ marginLeft: 8 }}>
        {copied ? (
          <CheckCircle fontSize="small" style={{ fontSize, color: GREEN400 }} />
        ) : (
          <ContentCopy fontSize="small" style={{ fontSize }} />
        )}
      </IconButton>
    </CopyToClipboard>
  );
};
export default CopyIconButton;
